import { ILocationViewModel } from "component-library/src/components/Organisms/LocationList/LocationList";
import { IAboutYouFormPhotoModel } from "../../../../formModels/AboutYouFormModel";

export enum DetailsPageHeadshotFormFields {
  Photo = "photo",
  PhotographerName = "photographerName",
}

export enum DetailsPageFormFields {
  Headshot = "headshot",
  Agent = "agent",
  Gender = "gender",
  GenderNonBinaryCustom = "genderNonBinaryCustom",
  GenderFurtherInfo = "genderFurtherInfo",
  DisplayGender = "displayGender",
  Location = "location",
}

export interface IGraduatesDetailsFormFields extends IAboutYouFormPhotoModel {
  [DetailsPageFormFields.Agent]: number | null;
  [DetailsPageFormFields.Gender]: number | null;
  [DetailsPageFormFields.GenderNonBinaryCustom]: number | null;
  [DetailsPageFormFields.GenderFurtherInfo]: string;
  [DetailsPageFormFields.DisplayGender]: boolean;
  [DetailsPageFormFields.Location]: ILocationViewModel[];
}
